import { SearchScope } from '../utils/types';
import { fetchSearchSuggestions } from './apiFetchSearchSuggestions';
import { useQuery } from '@tanstack/react-query';
import { ErrorResponse, globalErrorResponse } from '../../notification/actions';
import useDebounce from '../../hooks/useDebounce';
import { isCatalogueSearchScope } from '../utils/constants';
import { GlobalReactQueryOptions } from '../../../config';

const SEARCH_SUGGESTIONS_QUERY_KEY = 'search-suggestions';

export const useDebouncedSearchResults = ({
    query,
    scope,
    shopLanguage
}: {
    query: string;
    scope: SearchScope;
    shopLanguage: string | undefined;
}) => {
    const [debouncedQuery] = useDebounce(query, 420);

    return useQuery(
        [SEARCH_SUGGESTIONS_QUERY_KEY, { debouncedQuery, scope, shopLanguage }],
        () => fetchSearchSuggestions({ query: debouncedQuery, scope, shopLanguage }),
        {
            ...GlobalReactQueryOptions,
            enabled: !!debouncedQuery && isCatalogueSearchScope(scope),
            onError: (error: ErrorResponse) => globalErrorResponse(error)
        }
    );
};
